import React from "react";  

import {  
    
} from "./styled";

import ContainerAuthenticated from "containers/Authenticated";
import { Row, Col } from "reactstrap";
import { useHistory } from "react-router-dom";

import DashboardFormsVacantion from "components/Dashboard/Forms/Vacantion";

export default function DashboardFormVacantion(){  

    const history = useHistory(); 
    const navigate = to => history.push(`/${ to }`); 

    return ( 
        <>
            <ContainerAuthenticated page={"vacantion"}> 
                <Row> 
                    <Col sm={12} md={12}>
                        <DashboardFormsVacantion />
                    </Col>
                </Row>
            </ContainerAuthenticated> 
        </>
    );
}